import { NgModule, CUSTOM_ELEMENTS_SCHEMA, ApplicationModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GridModule } from '@progress/kendo-angular-grid';
import { PrettyJsonModule } from 'angular2-prettyjson';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { RvrsCreateComponent } from './rvrs-create.component';
import { RvrsCreateFromExistingModule } from './rvrs-create-from-existing/rvrs-create-from-existing.module';
import { RvrsCreateFromFileModule } from './rvrs-create-from-file/rvrs-create-from-file.module';
import { RvrsCreateManualModule } from './rvrs-create-manual/rvrs-create-manual.module';
import { WizardModule } from '../../../common/component/wizard/wizard.module';
import{ ModalModule } from '../../../common/component/modal/modal.module';
import { UploadModule } from '@progress/kendo-angular-upload';
import { FormsModule } from '@angular/forms';
import { NglModule} from 'ng-lightning';
import { PropertyEditModule } from '../../rate-audit/ra-create/property-edit/property-edit.module';
import { ProcessSettingsModule } from '../../rate-audit/ra-create/process-settings/process-settings.module';
import { SpinnerModule } from '../../../common/component/spinner/spinner.module';
import { RvrsCreateStep2Module } from './rvrs-create-step2/rvrs-create-step2.module';
import { RvrsCreateStep3Module } from 'app/main/rvrs-audit/rvrs-create/rvrs-create-step3/rvrs-create-step3.module';

import { ConfirmDialogModule } from '../../../common/component/confirm-dialog/confirm-dialog.module';

@NgModule({
    imports: [
      CommonModule,
      GridModule,
      ModalModule,
      PrettyJsonModule,
      DialogModule,
      WizardModule,
      UploadModule,
      FormsModule,
      NglModule,
      ApplicationModule,
      PropertyEditModule,
      ProcessSettingsModule,
      SpinnerModule,
      RvrsCreateFromExistingModule,
      RvrsCreateFromFileModule,
      RvrsCreateManualModule,
      RvrsCreateStep2Module,
      RvrsCreateStep3Module,
      ConfirmDialogModule
    ],
    declarations: [RvrsCreateComponent],
    exports: [RvrsCreateComponent],
    schemas:[ CUSTOM_ELEMENTS_SCHEMA ]
})
export class RvrsCreateModule { }
